import { COUNTRIES, maskPhone } from "@/design/phone";

/**
 * Um telefone E.164 como uma pessoa o lê: "+55 12 98700-0070".
 *
 * A lista de conversas mostrava "Visitante" para um WhatsApp sem nome — a API
 * oficial não transmite `pushName`, e o contato nasce só com o número. O número
 * é o nome honesto nesse caso, mas "+5512987000070" não se lê. Brasil ganha a
 * grafia local (DDI, DDD, e o hífen antes dos quatro últimos); os outros países
 * da tabela do seletor (`design/phone`) ganham a máscara deles, mas só quando o
 * tamanho bate EXATO — o resto vai inteiro com o "+", porque partir errado é pior.
 * Qualquer coisa que não seja um E.164 volta como veio.
 */
export function formatPhone(raw: string | null | undefined): string | null {
	if (!raw) return null;
	const digits = raw.replace(/\D/g, "");
	if (!/^\+?\d{8,15}$/.test(raw.replace(/[\s()-]/g, ""))) return raw;

	if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13)) {
		const ddd = digits.slice(2, 4);
		const local = digits.slice(4);
		return `+55 ${ddd} ${local.slice(0, -4)}-${local.slice(-4)}`;
	}

	// DDI mais longo primeiro, para o "+1" nunca engolir um "+351".
	const country = [...COUNTRIES]
		.sort((a, b) => b.dial.length - a.dial.length)
		.find((c) => digits.startsWith(c.dial) && digits.length - c.dial.length === c.localLength);
	return country
		? `+${country.dial} ${maskPhone(country, digits.slice(country.dial.length))}`
		: `+${digits}`;
}
